import { gsap } from "gsap";
import barba from "@barba/core";
import Headroom from "headroom.js";
import { ScrollSpy } from "bootstrap";
import Alpine from "alpinejs";

// Store the hooks in an object so they can be replaced
const barbaHooks = {
  beforeLeave: () => {},
  after: () => {},
};

// Register barba hooks once, calling the assigned functions dynamically
barba.hooks.beforeLeave(() => {
  barbaHooks.beforeLeave()
});
barba.hooks.after(() => {
  barbaHooks.after()
})

Alpine.data("anchorMenu", () => ({
  headroom: null,
  init() {
    if (document.querySelector('.wp-admin')) return;

    this.initScrollSpy();

    barbaHooks.after = () => {
      this.initScrollSpy()
    }
    barbaHooks.beforeLeave = () => {
      this.destroy();
    };

    document.querySelector('.c-nav').classList.add('has-anchor-menu');

    this.headroom = new Headroom(this.$root);
    this.headroom.init();
  },
  initScrollSpy() {
    ScrollSpy.getOrCreateInstance(document.querySelector('main'), {
      target: '#anchor-menu',
      offset: 50
    })?.refresh();
  },
  destroy() {
    document.querySelector('.c-nav').classList.remove('has-anchor-menu');
    this.headroom.destroy();
  }
}));